import { CoreMenu } from '@core/types'

const baseMenu: CoreMenu[] = [
  {
    id: 'service',
    type: 'section',
    title: 'Сервиз',
    translate: 'Сервиз',
    children: [
      {
        id: 'orders',
        title: 'Поръчки',
        translate: 'Поръчки',
        type: 'collapsible',
        icon: 'dollar-sign',
        children: [
          {
            id: 'orders-all',
            title: 'Всички поръчки',
            translate: 'Всички поръчки',
            type: 'item',
            icon: 'circle',
            url: 'orders/list/all'
          },
          {
            id: 'orders-warranty',
            title: 'Гаранционни поръчки',
            translate: 'Гаранционни поръчки',
            type: 'item',
            icon: 'circle',
            url: 'orders/list/warranty'
          },
          {
            id: 'orders-nowarranty',
            title: 'Извънгаранционни поръчки',
            translate: 'Извънгаранционни поръчки',
            type: 'item',
            icon: 'circle',
            url: 'orders/list/nowarranty'
          }
        ]
      },
      {
        id: 'companies',
        title: 'Доставки',
        translate: 'Доставки',
        type: 'item',
        icon: 'truck',
        url: 'deliveries/list'
      },
      {
        id: 'sales',
        title: 'Продажби',
        translate: 'Продажби',
        type: 'item',
        icon: 'trending-up',
        url: 'sales/list'
      },
      {
        id: 'dashboard',
        title: 'Справки',
        translate: 'Справки',
        type: 'collapsible',
        icon: 'pie-chart',
        children: [
          {
            id: 'analytics',
            title: 'Справки',
            translate: 'Справки',
            type: 'item',
            icon: 'circle',
            url: 'stats/show'
          },
          {
            id: 'ecommerce',
            title: 'Справки продажби',
            translate: 'Справки продажби',
            type: 'item',
            icon: 'circle',
            url: 'stats-orders/show'
          }
        ]
      },
    ]
  },

  {
    id: 'data',
    type: 'section',
    title: 'Данни',
    translate: 'Данни',
    children: [
      {
        id: 'parts',
        title: 'Части',
        translate: 'Части',
        type: 'item',
        icon: 'cpu',
        url: 'parts/list'
      },
      {
        id: 'counterparties',
        title: 'Контрагенти',
        translate: 'Контрагенти',
        type: 'item',
        icon: 'users',
        url: 'counterparties/list'
      },
      {
        id: 'endpoints',
        title: 'Обекти',
        translate: 'Обекти',
        type: 'item',
        icon: 'octagon',
        url: 'endpoints/list'
      },
      {
        id: 'services',
        title: 'Сервизи',
        translate: 'Сервизи',
        type: 'item',
        icon: 'tool',
        url: 'services/list'
      },
      {
        id: 'settings',
        title: 'Настройки',
        translate: 'Настройки',
        type: 'item',
        icon: 'settings',
        url: 'settings'
      }
    ]
  }
];

const adminMenu: CoreMenu[] = [
  ...baseMenu,
  {
    id: 'admin',
    type: 'section',
    title: 'Административни',
    translate: 'Административни',
    children: [
      {
        id: 'companies',
        title: 'Компании',
        translate: 'Компании',
        type: 'item',
        icon: 'award',
        url: 'companies/list'
      },
      {
        id: 'users',
        title: 'Потребители',
        translate: 'Потребители',
        type: 'item',
        icon: 'user-check',
        url: 'users/list'
      }
    ]
  }
];

const ownerMenu: CoreMenu[] = [
  ...baseMenu,
  {
    id: 'admin',
    type: 'section',
    title: 'Административни',
    translate: 'Административни',
    children: [
      {
        id: 'companies',
        title: 'Компании',
        translate: 'Компании',
        type: 'item',
        icon: 'award',
        url: 'companies/list'
      },
      {
        id: 'users',
        title: 'Потребители',
        translate: 'Потребители',
        type: 'item',
        icon: 'user-check',
        url: 'users/list'
      }
    ]
  }
];

const workerMenu: CoreMenu[] = [
  {
    id: 'service',
    type: 'section',
    title: 'Сервиз',
    translate: 'Сервиз',
    children: [
      {
        id: 'orders',
        title: 'Поръчки',
        translate: 'Поръчки',
        type: 'collapsible',
        icon: 'dollar-sign',
        children: [
          {
            id: 'orders-all',
            title: 'Всички поръчки',
            translate: 'Всички поръчки',
            type: 'item',
            icon: 'circle',
            url: 'orders/list/all'
          },
          {
            id: 'orders-warranty',
            title: 'Гаранционни поръчки',
            translate: 'Гаранционни поръчки',
            type: 'item',
            icon: 'circle',
            url: 'orders/list/warranty'
          },
          {
            id: 'orders-nowarranty',
            title: 'Извънгаранционни поръчки',
            translate: 'Извънгаранционни поръчки',
            type: 'item',
            icon: 'circle',
            url: 'orders/list/nowarranty'
          }
        ]
      },
      {
        id: 'companies',
        title: 'Доставки',
        translate: 'Доставки',
        type: 'item',
        icon: 'truck',
        url: 'deliveries/list'
      },
      {
        id: 'sales',
        title: 'Продажби',
        translate: 'Продажби',
        type: 'item',
        icon: 'trending-up',
        url: 'sales/list'
      }
    ]
  },

  {
    id: 'data',
    type: 'section',
    title: 'Данни',
    translate: 'Данни',
    children: [
      {
        id: 'parts',
        title: 'Части',
        translate: 'Части',
        type: 'item',
        icon: 'cpu',
        url: 'parts/list'
      },
      {
        id: 'counterparties',
        title: 'Контрагенти',
        translate: 'Контрагенти',
        type: 'item',
        icon: 'users',
        url: 'counterparties/list'
      },
      {
        id: 'endpoints',
        title: 'Обекти',
        translate: 'Обекти',
        type: 'item',
        icon: 'octagon',
        url: 'endpoints/list'
      },
      {
        id: 'services',
        title: 'Сервизи',
        translate: 'Сервизи',
        type: 'item',
        icon: 'tool',
        url: 'services/list'
      }
    ]
  }
];

const clientMenu: CoreMenu[] = [
  {
    id: 'service',
    type: 'section',
    title: 'Сервиз',
    translate: 'Сервиз',
    children: [
      {
        id: 'orders',
        title: 'Моите поръчки',
        translate: 'Моите поръчки',
        type: 'item',
        icon: 'dollar-sign',
        url: 'orders/list/my'
      }
    ]
  }
];

export const menu = adminMenu; // Default for backward compatibility

export const getMenuByRole = (role: string): CoreMenu[] => {
  switch (role) {
    case 'admin':
      return adminMenu;
    case 'owner':
      return ownerMenu;
    case 'worker':
      return workerMenu;
    case 'client':
      return clientMenu;
    default:
      return baseMenu;
  }
};
